import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FullSizeCenteredColumn } from '../FlexBox';
import Dialog from '../Dialog';
import {
  flattenRoutes,
  renderRoutesTree,
  resolveRouteKey,
} from '../../Router/routes';
import { CHANNEL_TYPES } from '../../Utils/constants/general';
import { selectedBranchAtom } from '../../Atoms';

const DefaultPageDialog = function DefaultPageDialog({
  open,
  defaultValue,
  onClose,
  onSubmit,
  routesTree = [],
}) {
  const intl = useIntl();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const [value, setValue] = useState(defaultValue);

  // Channel-filtered and flat: only offer pages reachable in this channel.
  // Options are canonical route keys, never the server `name` — that can be a
  // GUID, which would both display as one and be stored as the user's default.
  const routesOptions =
    flattenRoutes(
      renderRoutesTree(
        routesTree,
        selectedBranch?.channelType === CHANNEL_TYPES.Long
      )
    )
      ?.map((route) => resolveRouteKey(route))
      .filter(Boolean) || [];

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleClose = () => {
    onClose('');
    setValue('');
  };

  const handleSubmit = () => {
    onSubmit(value);
  };

  // Read on opening: by then the routes are loaded, and a previous close has emptied the value.
  useEffect(() => {
    if (!open) return;
    setValue(routesOptions.includes(defaultValue) ? defaultValue : 'CUSTOMERS');
  }, [open, defaultValue]);

  return (
    <Dialog
      id="default-page-dialog"
      title="SELECT_DEFAULT_PAGE"
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      width="sm"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      dividers
    >
      <FullSizeCenteredColumn padding="16px">
        <FormControl fullWidth>
          <InputLabel id="default-page-select-inputlabel">
            {intl.messages.DEFAULT_PAGE}
          </InputLabel>
          <Select
            id="default-page-select"
            label={intl.messages.DEFAULT_PAGE}
            value={value}
            onChange={handleChange}
          >
            {routesOptions.map((routeName) => {
              return (
                <MenuItem key={routeName} value={routeName}>
                  {intl.messages[routeName] || routeName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </FullSizeCenteredColumn>
    </Dialog>
  );
};

export default DefaultPageDialog;
